// extracted by mini-css-extract-plugin
var _1 = "#68914d";
var _2 = "#9cc681";
var _3 = "#8ab46f";
var _4 = "8px";
var _5 = "6px";
var _6 = "8px";
var _7 = "0 1px 1px 0 rgba(0,0,0,.02) inset";
var _8 = "0 8px 8px -4px rgba(0,0,0,.03),0 16px 24px -4px rgba(0,0,0,.08)";
var _9 = "10px";
var _a = "#e8e8e8";
var _b = "16px 24px";
var _c = "#38aa73";
var _d = "#956c22";
var _e = "#2988bd";
var _f = "#eee";
var _10 = "#c4842d";
var _11 = "#b8567c";
var _12 = "#8b6e4e";
var _13 = "#5889c2";
var _14 = "#4e8a8a";
var _15 = "#6a8a3e";
var _16 = "#7b5ea7";
var _17 = "#4a6fa5";
var _18 = "#3a8a6e";
var _19 = "#c25b4e";
var _1a = "#fafbfc";
var _1b = "#1e3050";
var _1c = "#293d62";
var _1d = "#fafbfc";
var _1e = "rgba(0,0,0,.12)";
var _1f = "#d9d9d9";
var _20 = "rgba(5,5,5,.1)";
var _21 = "#eaf2fc";
var _22 = "rgba(0,0,0,.65)";
var _23 = "#ebebeb";
var _24 = "#068467";
var _25 = "rgba(6,132,103,.1)";
var _26 = "#dc4949";
var _27 = "rgba(220,73,73,.1)";
var _28 = "#787c81";
var _29 = "#d6d9dc";
var _2a = "#f3f5f7";
var _2b = "#73c9b2";
var _2c = "linear-gradient(180deg, #73C9B2 0%, #B8E7DA 100%)";
var _2d = "#b8e7da";
var _2e = "#5357f8";
var _2f = "rgb(14.3921787709,19.9877094972,245.2078212291)";
var _30 = "rgb(249.6189944134,249.7441340782,254.7810055866)";
var _31 = "#f7f8f9";
var _32 = "#edeeef";
var _33 = "#7b8996";
var _34 = "#ededed";
var _35 = "#f4f5f7";
var _36 = "#fbfbfc";
var _37 = "rgba(0,0,0,.75)";
var _38 = "rgba(171.2567039106,172.4612273574,220.9432960894,.95)";
var _39 = "rgba(0,0,0,.3)";
var _3a = "rgba(0,0,0,.5)";
var _3b = "rgba(0,0,0,.4)";
var _3c = "rgba(0,0,0,.95)";
var _3d = "rgba(0,0,0,.65)";
var _3e = "rgba(0,0,0,.85)";
var _3f = "20px";
var _40 = "#f41e28";
var _41 = "1063px";
var _42 = "email-text___lrQaw";
var _43 = "rgba(227,89,86,.2)";
var _44 = "#e35956";
var _45 = "16px 24px";
var _46 = "28px";
var _47 = "32px";
var _48 = "18px";
var _49 = "14px";
var _4a = "14px";
var _4b = "15px";
var _4c = "12.6px";
var _4d = "11px";
var _4e = "20px";
var _4f = "28px";
var _50 = "700";
var _51 = "200";
var _52 = "300";
var _53 = "500";
var _54 = "400";
var _55 = "600";
var _56 = "get-help-menu___ePzs0";
var _57 = "hsla(0,0%,100%,.2)";
var _58 = "#ccc";
var _59 = "49px";
var _5a = "helpNavItemDisabledWrap___IAiZw";
var _5b = "icon-circle___hCg2U";
var _5c = "5px";
var _5d = "impersonation-pill-enter___wHCOT";
var _5e = "impersonationPill___k9CS7";
var _5f = "impersonationPillButton___JeNo5";
var _60 = "impersonationPillDivider___G0s_7";
var _61 = "impersonationPillLabel___QfzRe";
var _62 = "impersonationToastIcon___E7tPo";
var _63 = "impersonationTopLine___KwfQJ";
var _64 = "#5357f8";
var _65 = "rgba(0,0,0,.4)";
var _66 = "navBadge___MaoJb";
var _67 = "navButton___WDU04";
var _68 = "organization-text___QXsy4";
var _69 = "#fafafa";
var _6a = "hsla(0,0%,100%,.9)";
var _6b = "profile-info___gilAx";
var _6c = "profile-menu___zUwg8";
var _6d = "15px";
var _6e = "20px";
var _6f = "24px";
var _70 = "hsla(0,0%,100%,.6)";
var _71 = "#7e7eff";
var _72 = "hsla(0,0%,100%,.7)";
var _73 = "hsla(0,0%,100%,.3)";
var _74 = "hsla(0,0%,100%,.575)";
var _75 = "60px";
var _76 = "208px";
var _77 = "rgba(82,196,26,.2)";
var _78 = "#52c41a";
var _79 = "12px";
var _7a = "20px";
var _7b = "rgba(250,173,20,.2)";
var _7c = "#faad14";
var _7d = "#fff";
var _7e = "hsla(0,0%,100%,.2)";
export { _1 as "actionButtonColorDark", _2 as "actionButtonColorLight", _3 as "actionButtonColorMedium", _4 as "borderRadiusCard", _5 as "borderRadiusMain", _6 as "borderRadiusSurface", _7 as "boxShadowInnerXs", _8 as "boxShadowXl", _9 as "btnRightMargin", _a as "cardBorderColor", _b as "cardPadding", _c as "changeSetCompletedColor", _d as "changeSetManuallyChangesProposed", _e as "changeSetScheduledChangesProposed", _f as "chipBackground", _10 as "colorAccentAmber", _11 as "colorAccentBerry", _12 as "colorAccentBrown", _13 as "colorAccentCornflower", _14 as "colorAccentCyan", _15 as "colorAccentOlive", _16 as "colorAccentPurple", _17 as "colorAccentSteelBlue", _18 as "colorAccentTeal", _19 as "colorAccentTerracotta", _1a as "colorBackgroundMain", _1b as "colorBackgroundSidebar", _1c as "colorBackgroundSidebarHover", _1d as "colorBackgroundTabs", _1e as "colorBorderContainer", _1f as "colorBorderMain", _20 as "colorBorderSecondary", _21 as "colorDeltaCyanBlueBg", _22 as "colorDeltaGray", _23 as "colorDeltaGrayBg", _24 as "colorDeltaGreen", _25 as "colorDeltaGreenBg", _26 as "colorDeltaRed", _27 as "colorDeltaRedBg", _28 as "colorDetailsFieldText", _29 as "colorDetailsIcon", _2a as "colorDetailsTagBg", _2b as "colorMint", _2c as "colorMintGradient", _2d as "colorMintLight", _2e as "colorPrimary", _2f as "colorPrimaryHover", _30 as "colorPrimaryLightened", _31 as "colorTableHeadBg", _32 as "colorTableHeadBgHover", _33 as "colorTableHeadSubtitle", _34 as "colorTableRowBorder", _35 as "colorTableTextBg", _36 as "colorTableTotalRowBg", _37 as "colorTextBase", _38 as "colorTextDisabled", _39 as "colorTextExtraLight", _3a as "colorTextLight", _3b as "colorTextLighter", _3c as "colorTextMainHeading", _3d as "colorTextMuted", _3e as "colorTextPrimary", _3f as "contentHorizPadding", _40 as "dangerColor", _41 as "dashboardPdfContentWidth", _42 as "email-text", _43 as "errorBackcolor", _44 as "errorColor", _45 as "filterPanelPadding", _46 as "filtersDefaultHeight", _47 as "filtersTallHeight", _48 as "fontSizeLarge", _49 as "fontSizeMain", _4a as "fontSizeMedium", _4b as "fontSizePlus", _4c as "fontSizeSmaller", _4d as "fontSizeSmallest", _4e as "fontSizeXLarge", _4f as "fontSizeXxLarge", _50 as "fontWeightBold", _51 as "fontWeightExtraLight", _52 as "fontWeightLight", _53 as "fontWeightMediumBold", _54 as "fontWeightNormal", _55 as "fontWeightSemiBold", _56 as "get-help-menu", _57 as "ghostWhite", _58 as "grayBackgroundColor", _59 as "headerHeight", _5a as "helpNavItemDisabledWrap", _5b as "icon-circle", _5c as "iconHorizontalMargin", _5d as "impersonation-pill-enter", _5e as "impersonationPill", _5f as "impersonationPillButton", _60 as "impersonationPillDivider", _61 as "impersonationPillLabel", _62 as "impersonationToastIcon", _63 as "impersonationTopLine", _64 as "linkColor", _65 as "linkColorMuted", _66 as "navBadge", _67 as "navButton", _68 as "organization-text", _69 as "popoverHeaderColor", _6a as "popoverMaskColor", _6b as "profile-info", _6c as "profile-menu", _6d as "rowPadding", _6e as "ruleInnerGutters", _6f as "ruleSideGutters", _70 as "sideMenuIconColor", _71 as "sideMenuIconSelectedColor", _72 as "sideMenuItemColor", _73 as "sideMenuScrollbarThumbColor", _74 as "sideMenuSubmenuItemColor", _75 as "sidebarCollapsedWidth", _76 as "sidebarWidth", _77 as "successBackcolor", _78 as "successColor", _79 as "tableHeaderVerticalPadding", _7a as "tableHorizPadding", _7b as "warningBackcolor", _7c as "warningColor", _7d as "whiteColor", _7e as "whiteDividerColor" }
